import { httpRequest } from '../util/api-common.util';

class ErrataAPI {
  static listarErratas(laudo) {
    return httpRequest(`laudos/errata/${laudo}`);
  }
}

export default ErrataAPI;



// WEBPACK FOOTER //
// ./src/app/common/multierratas/multierratas.api.js